/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";

import { loadRuntimeConfig } from "./app/shared/config/runtime-config";

loadRuntimeConfig()
  .then(async () => {
    const [{ App }, { appConfig }] = await Promise.all([
      import("./app/app"),
      import("./app/app.config"),
    ]);

    bootstrapApplication(App, appConfig).catch((err) => console.error(err));
  })
  .catch((error: unknown) => {
    console.error("Application startup failed.", error);
  });
